module.exports = "data:image/png;base64,UklGRtAAAABXRUJQVlA4IMQAAABwBQCdASofAB8APmkskUWkIqGYDAYAQAaEtIACH9eQ/KfJ4qx0UkhKejYX2bkez2ugJAAAAP7+whLXRsm+gtv9KXiT9tvimKv3/zVzHTEKKer6a6Wgv9iy9YTYawsS7KN5Hr8JILpbXzTHif/+lLNkG0OXvYJ5wHFqRlTHeRmHk//3v6QNAf7i5nY8XKqv//Gm/5j+5+NSwQd0KZU4GQj+ez5ujURJZD4H474NUg5WqVwVeu5fw54Ym7FuvyyEYHfsAAAA"


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/Information/news60/news60_20.png
// module id = 4OPP
// module chunks = 0